<template>
  <div>
    <slot v-bind:toggle="toggle">
      <button @click="toggle()">Open</button>
    </slot>
    <q-dialog v-model="dialog" class="modal" full-height>
      <div class="suggestions-modal-iframe-wrapper">
        <iframe
          src="https://forms.monday.com/forms/embed/5b174266d4831739a77cf1900e2e77c6?r=use1"
          width="900"
          height="100%"
          style="border: 0; box-shadow: 5px 5px 56px 0px rgba(0, 0, 0, 0.25)"
        ></iframe>
      </div>
    </q-dialog>
  </div>
</template>

<script>
export default {
	data: () => ({
		dialog: false,
	}),
	methods: {
		toggle () {
			this.dialog = !this.dialog;
		},
	},
};
</script>

<style lang="stylus">
.suggestions-modal-iframe-wrapper {
  max-width: 900px !important;
  background: rgb(87, 92, 150);
}

.q-dialog.fullscreen {
  z-index: 1500000;
}
</style>